<template>
	<nuxt />
</template>

<script>
	export default {
		name: 'BlankLayout'
	}
</script>
